// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { PONumberParameter } from "@store/Framework/Store/Greif/Pages/CheckoutShipping/PONumber/PONumberTypes";

import { Draft } from "immer";

type PONumberState = Toolkit.Store.Greif.Pages.CheckoutShipping.PONumber.State;

const initialState: PONumberState = {
    poNumber: "",
    isLoading: false,
};

const actions = {
    "Greif/PagesReducer/PONumber/BegingUpdate": (draft: Draft<PONumberState>) => {
        draft.isLoading = true;
    },
    "Greif/PagesReducer/PONumber/CompleteUpdate": (draft: Draft<PONumberState>) => {
        draft.isLoading = false;
    },
    "Greif/PagesReducer/CheckoutShipping/SetPONumber": (
        draft: Draft<PONumberState>,
        action: { parameter: PONumberParameter },
    ) => {
        draft.poNumber = action.parameter.poNumber;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifCheckoutShippingPagesReducerPONumberActions = Parameters<typeof reducer>[1];
export default reducer;
